module.exports = __webpack_public_path__ + "static/media/Niveau_elN13_0_943050.a05842c1.png";